// Decides whether ROUTE_QUERY needs refetching. Timestamps catch updates, ids catch inserts and
// deletes. Sorted because Hasura does not guarantee row order without an order_by, and a reorder
// reading as a change would refetch every poll.

// `extra` is for rows whose meaningful changes never move a timestamp.
const stamp = (rows, idKey, extra) =>
    (rows || [])
        .map((row) => `${row[idKey]}@${row.last_modified_at ?? ''}${extra ? `:${extra(row)}` : ''}`)
        .sort()
        .join(',');

export const routeChangeFingerprint = (route) => {
    if (!route) return null;

    const orders = (route.orders || [])
        .map(({ mapping_id, type, duplicate_override, order }) =>
            [
                mapping_id,
                type ?? '',
                duplicate_override ?? '',
                order?.order_id,
                order?.last_modified_at ?? '',
                stamp(order?.wh_events, 'event_id'),
                stamp(
                    order?.exceptions,
                    'mapping_id',
                    (row) =>
                        `${row.exception?.last_modified_at ?? ''}/${row.exception?.status ?? ''}/${
                            row.exception?.resolution ?? ''
                        }`
                ),
                stamp(order?.itemsByOrderId, 'item_id'),
                stamp(order?.ratings, 'rating_id'),
            ].join('|')
        )
        .sort()
        .join(';');

    return [route.route_id, route.last_modified_at ?? '', stamp(route.stopsByRouteId, 'stop_id'), orders].join('~');
};
